import styled from "styled-components";

export const Container = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    width: fit-content;
`;

export const Main = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const IrctcPnrFlowContainer = styled.div`
    height: 100vh;
    width: 100%;

    @supports (padding-top: var(--sat)) {
        padding-top: var(--sat);
    }

    @supports (padding-bottom: var(--sab)) {
        padding-bottom: var(--sab);
    }
`;

export const VoucherPageContainer = styled.div`
    height: 100vh;
    width: 100%;

    @supports (padding-top: var(--sat)) {
        padding-top: var(--sat);
    }
`;

export const ShuttleAppName = styled.div({
    display: "none",
});

export const LoaderContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const Center = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    background-color: ${(props) => props.theme.colors[props.theme.colorMode].background_Secondary};
`;

export const ImageWrapper = styled(Center)`
    height: 120px;
`;
